import { Injectable } from '@angular/core';
import { DialogService } from "primeng/api";
import { ResponseMessageTypes } from "../enums/enum";
import { ExtensionModalComponent } from "../layouts/app-header/extension-modal.component";
import { RxjsService } from './rxjs.services';
import { SnackbarService } from './snackbar.service';

@Injectable({ providedIn: 'root' })
export class AgentLoginService {
  constructor(public dialogService: DialogService, private snackbarService: SnackbarService, private rxjsService: RxjsService) { }
  openOpenscapeLoginPopup() {
    this.snackbarService.openSnackbar("Agent login is required", ResponseMessageTypes.WARNING);
    this.dialogService.open(ExtensionModalComponent, { width: '450px', showHeader: false });
  }

  setCustomerDataAndExpandOpenscapeDialpad(data) {
    this.rxjsService.setCustomerContactNumber(data);
  }
}